import * as React from "react";
import type { SVGProps } from "react";
const SvgDocumentInvoiceContract = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.166 6.667H5.833M10.833 9.167h-5"
    />
    <circle
      cx={7.083}
      cy={12.916}
      r={1.25}
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.667 7.091V15a2.5 2.5 0 0 1-2.5 2.5H5A2.5 2.5 0 0 1 2.5 15V5A2.5 2.5 0 0 1 5 2.5h7.076a2.5 2.5 0 0 1 1.767.732l2.091 2.091a2.5 2.5 0 0 1 .733 1.768"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.666 7.083H13.75c-.92 0-1.667-.746-1.667-1.666V2.5"
    />
  </svg>
);
export default SvgDocumentInvoiceContract;
